<template>
  <div>
    <customer-list-desktop-bridge v-if="isDesktopListLayout" />
    <customer-list-mobile v-else />
    <v-dialog
      v-model="cardDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="cardDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2" />
        </v-col>
        <v-row class="ma-0">
          <card :account-prop="taskItem" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :turnover-prop="totals"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ accountListFilterTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-outline</v-icon>
              {{ $t("accountFilterStatus") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <div class="acf-switch">
                <span class="acf-switch__label">{{ $t("lead") }}</span>
                <v-switch
                  v-model="lead"
                  class="acf-switch__control mt-0 pt-0"
                  value="active"
                  color="primary"
                  dense
                  inset
                  hide-details
                  :ripple="false"
                />
              </div>
              <div class="acf-switch">
                <span class="acf-switch__label">{{ $t("active") }}</span>
                <v-switch
                  v-model="status"
                  class="acf-switch__control mt-0 pt-0"
                  value="active"
                  color="primary"
                  dense
                  inset
                  hide-details
                  :ripple="false"
                />
              </div>
              <v-select
                v-model="financialStatus"
                :label="$t('financial-status')"
                :items="financialStatusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <autocomplete
                v-model="category"
                :title="$t('category')"
                type="accountCategory"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="attractionMethod"
                :title="$t('attractionMethod')"
                type="attractionMethod"
                :multiple="true"
                :filter="true"
              />
              <tag v-model="tag" />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-office-building-outline</v-icon>
              {{ $t("sellFilterOrg") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="registerar"
                :title="$t('registerar')"
                type="partners"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>

          <section v-if="!isMobile && customFieldsPermission" class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-form-textbox</v-icon>
              {{ $t("sellFilterCustom") }}
            </div>
            <custom-field
              v-model="customFields"
              :value="customFields"
              type-prop="accountCustomFields"
              :multiple="true"
            />
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            ref="refTask"
            task-type="account"
            :ref-item="taskItem"
            ref-type="account"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialogList"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialogList = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("tasks") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task-list ref="refTaskList" type="account" :ref-id="refId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="accountDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon color="grey darken-2" @click="accountDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("new-account") }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: 350px">
            <account @close="accountDialog = false" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="customer"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="extensionDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="extensionDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <template>
            <v-text-field
              id="fromId"
              v-model="expireDate"
              :label="$t('expireDate')"
              outlined
              dense
              clearable
            />

            <date-picker
              v-model="expireDate"
              element="fromId"
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              auto-submit
              :color="
                this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                  .primary
              "
            />
          </template>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col class="px-0" cols="6">
              <v-btn color="primary" @click="setExtension">
                {{ $t("submit") }}
              </v-btn>
            </v-col>
            <v-col class="px-0" cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="extensionDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Task from "../task/task";
import TaskList from "../task/list";
import Account from "./customer";
import Upload from "../../components/general/upload/upload";
import General from "../../../../Mixins/general";
import Print from "../../components/general/Print/Index";
import customField from "../../components/general/customFields/index.vue";
import card from "./card.vue";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
import CustomerListDesktopBridge from "./layouts/desktop/CustomerListDesktopBridge.vue";
import CustomerListMobile from "./layouts/mobile/CustomerListMobile.vue";
import ProList from "@/Mixins/proList";
import PrintStudio from "@/modules/print/PrintStudio.vue";
import ProListFrame from "@/components/proList/ProListFrame.vue";
export default {
  name: "CustomerList",
  provide() {
    return { customerList: this };
  },
  components: {
    ProListFrame,
    PrintStudio,
    CustomerListDesktopBridge,
    CustomerListMobile,
    Tag: () => import("../../components/general/Tag/tag"),
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    card,
    Task,
    // pdfPrint,
    TaskList,
    customField,
    Upload,
    Account,
  },
  mixins: [General, ProList],
  props: [
    "input",
    "type",
    "data",
    "integratorTypeProp",
    "financialStatusProp",
    "mobileShow",
    "titleProp",
  ],
  data: () => ({
    pageCount: 1,
    page: 1,
    excelItems: [],
    printHeaders: [],
    selected: [],
    extensionDialog: false,
    extensionItem: null,
    customFields: null,
    cardDialog: false,
    expireDate: null,
    category: null,
    integratorType: null,
    rangeDate: null,
    registerar: null,
    attractionMethod: null,
    customerStatusItems: null,
    financialStatusItems: null,
    printDialog: false,
    uploadDialog: false,
    accountDialog: false,
    deletDialog: false,
    filter: false,
    financialStatus: null,
    customerStatus: null,
    status: "active",
    taskindex: 0,
    lead: null,
    refId: null,
    taskItem: null,
    model: null,
    from: 1,
    taskDialog: null,
    taskDialogList: null,
    showSelect: true,
    tag: null,
    temp: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    // Table pagination options. Kept separate from `options` because the
    // General mixin reuses `options` for money formatting and overwrites it
    // (beforeMount / currency watcher), which dropped page/itemsPerPage.
    tableOptions: {
      page: 1,
      itemsPerPage: 10,
    },
    deleteItem: null,
    headers: null,
    listViewportObserver: null,
    listViewportRaf: null,
    personnel: null,
    typeForm: "account",
    search: null,
    renderTable: null,
    selectedHeaders: [],
    hasDobarePermission: false,
    //   tableData: [
    //     { name: '<div style="color: blue;">John Doe</div>', age: 300000, country: '<button>USA</button>' },
    //     { name: '<strong>Jane Smith</strong>', age: 2500000, country: '<button>UK</button>' },
    //     { name: '<em>Kevin Brown</em>', age: 350000, country: '<button>Canada</button>' },
    //   ],
    //   columns: [
    //     {
    //       data: 'name',
    //       renderer: htmlRenderer, // استفاده از رندرکننده سفارشی برای نمایش HTML
    //     },
    //     {
    //       data: 'age',
    //       type: 'numeric',
    //     },
    //     {
    //       data: 'country',
    //       renderer: htmlRenderer, // استفاده از رندرکننده سفارشی برای نمایش HTML
    //     },
    //   ],
    //   hotSettings: {
    //     licenseKey: 'non-commercial-and-evaluation', // کلید لایسنس
    //     stretchH: 'all',
    //     autoWrapRow: true,
    //     height: 'auto',
    //     maxRows: 10,
    //     manualRowResize: true,
    //     manualColumnResize: true,
    //   },
  }),
  computed: {

    accountListFilterTitle() {
      var map = {
        customerList: "customerListFilterTitle",
        usersList: "usersListFilterTitle",
        leadList: "leadListFilterTitle",
        creditorList: "creditorListFilterTitle",
        debtorList: "debtorListFilterTitle",
        academyStudentList: "academyStudentListFilterTitle",
        academyTeacherList: "academyTeacherListFilterTitle",
      };
      var key = map[this.$route.name] || "customerListFilterTitle";
      return this.$t(key);
    },
    activeFilterChips() {
      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var pick = function (items, v, key) {
        var arr = Array.isArray(v) ? v : [v];
        return arr
          .map(function (x) {
            var f = (items || []).find(function (i) {
              return i.value === x;
            });
            return f ? f[key || "text"] : "";
          })
          .filter(Boolean)
          .join("، ");
      };
      var defs = [
        ["lead", app.$t("lead"), app.lead === "active" ? app.$t("lead") : ""],
        ["status", app.$t("active"), app.status === "active" ? app.$t("active") : ""],
        ["financialStatus", app.$t("financial-status"), pick(app.financialStatusItems, app.financialStatus)],
        ["category", app.$t("category")],
        ["attractionMethod", app.$t("attractionMethod")],
        ["registerar", app.$t("registerar")],
        ["tag", app.$t("tag")],
        ["branch", app.$t("branch")],
        ["customFields", app.$t("sellFilterCustom")],
      ];
      return defs
        .filter(function (d) {
          return has(app[d[0]]);
        })
        .map(function (d) {
          return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) };
        });
    },
    proListKey() {
      return this.accountListColumnPersistKey;
    },
    proListLocked() {
      return this.accountListLockedColumns;
    },
    isDesktopListLayout() {
      // Embedded usages (mobileShow) keep the desktop view as before
      if (this.mobileShow) return true;
      return this.$vuetify.breakpoint.width >= 800;
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    accountListColumnPersistKey() {
      return "account-list-columns-" + (this.$route.name || "customerList");
    },
    accountListLockedColumns() {
      // Fixed sticky block: select + #/action (no unpin/drag)
      var locked = ["action"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    accountListColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.accountListLockedColumns,
        anchor: "action",
        minWidth: 60,
        persistKey: this.accountListColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.type !== "sell") {
          if (s.value === "pre_invoice") {
          } else {
            if (s.align != "d-none") {
              return app.selectedHeaders.includes(s);
            }
          }
        } else {
          if (s.align != "d-none") {
            return app.selectedHeaders.includes(s);
          }
        }
      });
    },
    totals: function () {
      var app = this;
      const totals = this.items.reduce(
        (acc, d) => {
          acc.amount += parseFloat(d.remain ? d.remain.remain : 0);
          return acc;
        },
        {
          amount: 0,
        }
      );
      app.renderTable = true;
      return totals;
    },
  },
  watch: {
    taskDialogList(val) {
      if (!val) {
        this.getItems();
      }
    },
    taskDialog(val) {
      if (!val) {
        this.getItems();
      }
    },
    data(val) {
      this.model = val.description;
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.page = 1;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.tableOptions?.sortBy?.map(function (value) {
          const index = app.headers?.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        app.page = app.tableOptions?.page;
        app.itemsPerPage = app.tableOptions?.itemsPerPage;
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers?.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
  },
  activated() {
    // this.getItems()
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  beforeMount() {
    this.hasDobarePermission = JSON.parse(localStorage.getItem("hasDobarePermission"));

    if (this.$route.name === "leadList") {
      this.lead = "active";
    }
    if (this.$route.name === "usersList") {
      this.personnel = "active";
    }
    if (this.$route.name === "academyStudentList") {
      this.integratorType = "student";
    }
    if (this.$route.name === "academyTeacherList") {
      this.integratorType = "teacher";
    }
    if (this.$route.params.financialStatus) {
      this.financialStatus = this.$route.params.financialStatus;
    }
    this.customerStatusItems = [
      {
        value: "lead",
        text: this.$t("lead"),
      },
      {
        value: "on",
        text: this.$t("active"),
      },
    ];
    this.financialStatusItems = [
      {
        value: ">",
        text: this.$t("debtor"),
      },
      {
        value: "<",
        text: this.$t("creditor"),
      },
      {
        value: "=",
        text: this.$t("clearing"),
      },
    ];

    this.printHeaders = [
      {
        text: this.$t("name"),
        value: "name",
      },
      {
        text: this.$t("category"),
        value: "category.name",
        width: 15,
      },
      {
        text: this.$t("phone"),
        value: "phone",
        width: 10,
      },
      {
        text: this.$t("mobile"),
        value: "mobile",
        width: 10,
      },
      {
        text: this.$t("remain"),
        value: "remain.remain",
        type: "number",
        width: 15,
        sum: true,
      },
    ];
  },
  mounted() {
    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "action",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      /*   {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'users.id',
        }, */
      {
        text: this.$t("name and category"),
        sortable: true,
        value: "firstname",
        table: "users.name",
        width: 300,
      },
      {
        text: this.$t("national-code"),
        sortable: true,
        value: "national_code",
        table: "users.national_code",
      },
      {
        text: this.$t("remain"),
        sortable: true,
        value: "remain",
        table: "doc_article.remain",
      },
      /*   {
          text: this.$t('task-relation'),
          sortable: false,
          value: 'task-relation',
        }, */
      /*  {
          text: this.$t('customer-status'),
          sortable: false,
          value: 'status',
        }, */
      /*   {
          text: this.$t('attractionMethod'),
          sortable: false,
          value: 'attraction_method_id',
        }, */
      /*      {
          text: this.$t('category'),
          sortable: true,
          value: 'category.name',
          table: 'users_category.name',
        }, */
      {
        text: this.$t("connection-info"),
        sortable: false,
        value: "connection_info",
      },
      /*         {
          text: this.$t('mobile'),
          sortable: true,
          value: 'mobile',
          table: 'users.mobile',
        },
        {
          text: this.$t('email'),
          sortable: true,
          value: 'email',
          table: 'users.email',
        }, */
      {
        text: this.$t("address"),
        sortable: true,
        value: "address",
        table: "users.address",
      },
      {
        text: this.$t("other"),
        sortable: true,
        value: "content",
        table: "users.content",
      },
      {
        text: this.$t("club-credit"),
        sortable: true,
        value: "club_credit",
        align: !this.hasDobarePermission ? "d-none" : "center",
      },
      /* {
          text: this.$t('accountCode'),
          sortable: true,
          value: 'fin.fin_code',
          table: 'financial_detail_coding.code',
        }, */
      /*   {
          text: this.$t('financial-status'),
          sortable: false,
          value: 'state',
        }, */
      /*      {
          text: this.$t('point'),
          sortable: true,
          value: 'rank',
          table: 'users_rank.point',
        }, */
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "meta.branch.name",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
      // {
      //   text: this.$t('time'),
      //   sortable: false,
      //   value: 'time',
      // },
    ];

    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    reorderPinnedHeaders(this.headers, {
      locked: this.accountListLockedColumns,
      anchor: "action",
    });
    this.loadAccountListColumnSettings();
    if (this.input) {
      this.model = this.input;
    }
    if (this.financialStatusProp) {
      this.financialStatus = this.financialStatusProp;
    }
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
  methods: {

    resetFilters() {
      var app = this;
      [
        "lead", "status", "financialStatus", "category", "attractionMethod",
        "registerar", "tag", "branch", "customFields",
      ].forEach(function (k) {
        app[k] = null;
      });
      if (app.$route.name === "leadList") {
        app.lead = "active";
      }
      if (app.$route.params && app.$route.params.financialStatus) {
        app.financialStatus = app.$route.params.financialStatus;
      }
      if (app.financialStatusProp) {
        app.financialStatus = app.financialStatusProp;
      }
    },
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null || summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadAccountListColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.accountListColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.accountListLockedColumns,
          anchor: "action",
        });
        app.$forceUpdate();
      });
    },
    resolveClubCredit(item) {
      const dobare = item.customer_club_credit.find((obj) => obj.key == "customer_club_credit");
      if (dobare) {
        return this.$numberFormat(dobare.value) + " " + this.$store.state.currencySymbol;
      } else {
        return this.$t("haveNot");
      }
    },
    openExtensionDialog(item) {
      this.$router.push({
        name: "planAdministration",
        params: { abr: item.abr_id, name: item.name },
      });
    },
    setExtension() {
      var app = this;
      app.loading = true;
      app.extensionDialog = false;
      app.$axios
        .get(this.$endpoint + "customer", {
          params: {
            account: app.extensionItem,
            expireDate: app.expireDate,
          },
        })
        .then((res) => {
          res = res.data;
          app.getItems();
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 401) {
            this.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.loading = false));
    },
    openUploadDialog() {
      if (this.$root) {
        this.$root.$emit("open-user-file-process", { type: "customer" });
      }
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openCardDialog(item) {
      this.taskItem = item;
      this.cardDialog = true;
    },
    openTaskDialog(item) {
      if (this.$refs.refTask) {
        this.$refs.refTask.clearForm();
      }
      this.taskItem = item;
      this.taskDialog = true;
    },
    openTaskDialogList(item) {
      if (this.$refs.refTaskList) {
        this.$refs.refTaskList.getItems();
      }
      this.refId = item.id;
      this.taskDialogList = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      /* if($store.state.permissions) */
      this.$router.push({ name: "customerEdit", params: { id: item.id } });
    },
    payment(item, type) {
      this.$router.push({ name: type, params: { accountProp: item } });
    },
    teacherCostList(item) {
      this.$router.push({
        name: "academyTeacherSessionCostList",
        params: { teacherProp: item },
      });
    },
    events(item) {
      this.$router.push({ name: "academyEventList", params: { studentIdProp: item.id } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "customer/show", {
          params: {
            search: app.search,
            registerar: app.registerar,
            rangeDate: app.rangeDate,
            category: app.category,
            attractionMethod: app.attractionMethod,
            status: app.status,
            personnel: app.personnel,
            lead: app.lead,
            customFields: app.customFields,
            branch: app.branch,
            page: app.allRows ? app.excelPage : app.tableOptions.page,
            type: app.type,
            sortBy: app.sortBy,
            integratorType: app.integratorType,
            options: app.tableOptions,
            tag: app.tag,
            customerStatus: app.customerStatus,
            remainStatus: app.financialStatus,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.last_page = res.last_page;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 401) {
            this.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "customer/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value) {
        selected.push({ id: value.id });
      });
      app.$axios
        .delete(this.$endpoint + "customer/0", {
          params: { deleteItems: selected },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    print() {
      this.$htmlToPaper("print");
    },
    turnover(item) {
      this.$router.push({
        name: "turnoverDetail",
        params: {
          id: item.fin_id,
          accountProp: { fin_id: item.fin_id, name: item.name },
          tabName: item.name,
        },
      });
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          name: String(d.name),
          category: d.category ? d.category.name : "",
          phone: d.phone ? String(d.phone) : "",
          remain: d.remain ? d.remain.remain : "",
          mobile: d.mobile ? d.mobile : "",
          national_code: d.national_code ? d.national_code : "",
          email: d.email ? d.email : "",
          address: d.address ? d.address : "",
          content: d.content ? d.content : "",
          birth_date: d.birth_date ? d.birth_date : "",
          country: d.country ? d.country.name : "",
          state: d.state ? d.state.name : "",
          city: d.city ? d.city.name : "",
          finantial_code: d.fin && d.fin.fin_code ? d.fin.fin_code : "",
          financial_code: d.financial_code ? d.financial_code : "",
          tags: d.tags ? d.tags.map((item) => item.text).join(",") : "",
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* Desktop chrome: shared pro-list kit (slot content of ProListFrame) */
@import "~@/sass/design-system/list/pro-list";

/* Tighter rows: less cell padding and line height only — same layout. */
.pl ::v-deep .v-data-table tbody tr td {
  height: 30px !important;
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}
.pl ::v-deep .v-data-table tbody tr td .v-card__text,
.pl ::v-deep .v-data-table tbody tr td .text-caption {
  line-height: 1.2 !important;
}

.v-badge__badge {
  height: 16px !important;
  min-width: 16px !important;
  padding: 4px 6px !important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;
  min-height: 32px !important;
}
::v-deep .v-data-table table tbody tr {
  /* height: 72px; */
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-data-table table tbody tr td:nth-child(8) {
  white-space: unset;
  min-width: 185px;
}
.v-card__text {
  width: auto;
}
img {
  width: 32px;
  border-radius: 4px;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
/* ::v-deep .v-data-table {
    border: 1px solid #999999;
    border-radius: 6px !important;
    padding: 4px;
}
::v-deep .v-data-table__wrapper {
    margin-bottom: 5%;
}
::v-deep .v-data-table-header {
    background-color: #D9D9D9;
}
::v-deep .v-data-table-header tr th:first-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
::v-deep .v-data-table-header tr th:last-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
::v-deep .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    font-size: 8pt !important;
    color: #000;
}
    ::v-deep .theme--light.v-data-table.v-data-table--fixed-header thead th {
  background: #D9D9D9 !important;
}*/
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
/* ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
::v-deep .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  height: 40px;
} */
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  height: 48px;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}
</style>
